/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Menu from "@mui/material/Menu";
// import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

// Soft UI Dashboard PRO React example components
import BaseNavbarLink from "../BaseNavbar/BaseNavbarLink";

// BaseNavbar dropdown menu
import MenuOptions from "./MenuOptions";
import { useLocation } from "react-router-dom";

function BaseNavbarMobile({ routes, menuItems, open, close }) {
  const { width } = open && open.getBoundingClientRect();
  const [openCollapse, setOpenCollapse] = useState(false);

  const handleSepOpenCollapse = (name) =>
    openCollapse === name ? setOpenCollapse(false) : setOpenCollapse(name);

  function menuFilter(route, menuType) {
    return route.in_menu && route.key.includes(menuType);
  }

  const location = useLocation();

  useEffect(() => {
    // Close the menu whenever the location (URL) changes
    close();
  }, [location]);

  return (
    <Menu
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      anchorEl={open}
      open={Boolean(open)}
      onClose={close}
      MenuListProps={{ style: { width: `calc(100svw - 3rem)` } }}
    >
      <SoftBox px={0.5}>
        {menuItems.map((menuItem, itemIndex) => (
          <BaseNavbarLink
            key={itemIndex}
            name={menuItem}
            routes={routes.filter(r => menuFilter(r, menuItem))}
            collapseStatus={openCollapse === menuItem}
            onClick={() => handleSepOpenCollapse(menuItem)}
          >
            <SoftBox maxHeight="16rem" overflow="auto">
              <MenuOptions routes={routes.filter(r => menuFilter(r, menuItem))} route_path={menuItem} noCollapse={routes.filter(r => r.key == menuItem && !r.collapse).length > 0} mobileMenu />
            </SoftBox>
          </BaseNavbarLink>
        ))}
      </SoftBox>
    </Menu>
  );
}

// Typechecking props for the DefaultNavbarMenu
BaseNavbarMobile.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  menuItems: PropTypes.array.isRequired,
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  close: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
};

export default BaseNavbarMobile;
